<template>
    <div class="custom-table">
        <!-- filter -->
        <div class="filter">
            <el-form :inline="true" label-width="120px">
                <div class="col" v-for="(item, index) in tableFilter" :key="index"
                    :class="{ 'col-6': item.span == 6, 'col-8': item.span == 8 || !item.span, 'col-12': item.span == 12, 'col-18': item.span == 18, 'col-24': item.span == 24 }">
                    <el-form-item :label="item.label">
                        <el-select style="width: 100%;" v-if="item.type == 'select'" v-model="item.value" clearable
                            :filterable="item.filterable" :remote="item.filterable" :reserve-keyword="item.filterable"
                            :remote-method="val => remoteMethod(val, item)" :placeholder="'请选择' + item.label">
                            <el-option v-for="(opt, _opt) in item.opt" :key="_opt" :label="opt.label"
                                :value="opt.value">
                            </el-option>
                        </el-select>
                        <el-select style="width: 100%;" v-if="item.type == 'inputSelect'" v-model="item.value" filterable allow-create default-first-option clearable :placeholder="'请选择' + item.label">
                        <el-option v-for="(opt, _opt) in item.opt" :key="_opt" :label="opt.label"
                            :value="opt.value" :disabled="opt.disabled">
                        </el-option>
                    </el-select>
                        <el-cascader v-if="item.type == 'cascader'" :show-all-levels="false" style="width: 100%;"
                            :props="{ checkStrictly: true }" v-model="item.value" :options="item.opt"></el-cascader>
                        <el-input style="width: 100%;" v-if="item.type == 'input'" v-model="item.value" clearable
                            :disabled="item.disabled" :placeholder="'请输入' + item.label"></el-input>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <!-- btns -->
        <div class="btns" v-if="hasBtns">
            <el-button type="primary" @click="confirm">确认</el-button>
            <el-button @click="reset">重置</el-button>
        </div>
        <!-- table -->
        <div class="table">
            <div class="table-btns">
                <el-button v-for="(item, index) in btnsData" :key="index" @click="handelBtnClick(item.value)"
                    :type="item.type">{{ item.label }}
                </el-button>
            </div>

            <el-table :data="data" border>
                <el-table-column v-for="(item, index) in headerData" :key="index" :label="item.label" :prop="item.prop"
                    :align="item.align || 'center'">
                    <template slot-scope="scope">
                        <template v-if="item.type == 'switch'">
                            <span v-if="scope.row[item.prop + 'Disabled']">{{ scope.row[item.prop + 'Name'] }}</span>
                            <el-switch v-else v-model="scope.row[item.prop]" active-color="#13ce66"
                                @change="handelTableChange(scope.row, item.prop)" inactive-color="#c1b9b9">
                            </el-switch>
                        </template>
                        <el-select style="width: 100%;" v-if="item.type == 'select'" v-model="scope.row[item.prop]"
                            @change="handelTableChange(scope.row, item.prop)" size="small"
                            :placeholder="'请选择' + item.label">
                            <el-option v-for="(opt, _opt) in item.opt" :key="_opt" :label="opt.label"
                                :value="opt.value">
                            </el-option>
                        </el-select>
                        <template v-if="item.type == 'audit'">
                            <span v-if="scope.row[item.prop + 'Disabled']">{{ scope.row[item.prop + 'Name'] }}</span>
                            <CustomAudit v-else :options="item.opt" :data="scope.row[item.prop]"
                                @handelCustomChange="params => handelCustomChange(scope.row, item.prop, params)" />
                        </template>
                        <CustomTags v-if="item.type == 'tag'" :data="scope.row[item.prop]" />
                        <img v-if="item.type == 'image'" :src="scope.row[item.prop]" alt="" style="width: 120px;">
                        <span v-if="!item.type">{{ scope.row[item.prop] }}</span>
                    </template>
                </el-table-column>
                <slot></slot>
            </el-table>
        </div>

        <div class="pagination" v-if="hasPagination">
            <el-pagination @size-change="params => handelPageChange('size', params)"
                @current-change="params => handelPageChange('current', params)" :current-page="pageParams.current"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pageParams.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import CustomTags from "@/components/custom/CustomTags.vue"
import CustomAudit from "@/components/custom/CustomAudit.vue"
export default {
    components: { CustomTags, CustomAudit },
    data() {
        return {
            tableFilter: [],
            pageParams: {
                pageSize: 10,
                current: 1,
                total: 0
            },
        }
    },
    props: {
        filterData: {
            type: Array,
            default: () => {
                return []
            }
        },
        headerData: {
            type: Array,
            default: () => {
                return []
            }
        },
        hasBtns: {
            type: Boolean,
            default: true
        },
        btnsData: {
            type: Array,
            default: () => {
                return []
            }
        },
        data: {
            type: Array,
            default: () => {
                return []
            }
        },
        hasPagination: {
            type: Boolean,
            default: true
        },
        pagination: {
            type: Object,
            default: () => {
                return {
                    pageSize: 10,
                    current: 1,
                    total: 0
                }
            }
        }
    },
    watch: {
        "pagination": function (val) {
            this.pageParams = JSON.parse(JSON.stringify(val))
        },
        "filterData": function (val) {
            this.tableFilter = JSON.parse(JSON.stringify(val))
        }
    },
    created() {
        this.tableFilter = JSON.parse(JSON.stringify(this.filterData))
        this.search()
    },
    methods: {
        remoteMethod(query, item) {
            if (query !== '') {
                this.$https
                    .get(item.url, {
                        pageSize: 10000,
                        current: 0,
                        [item.key]: query
                    })
                    .then((res) => {
                        const data = res.data || []
                        item.opt = data.map(el => {
                            return {
                                label: el[item.key],
                                value: el.id
                            }
                        })
                    });
            } else {
                item.opt = [];
            }
        },
        // 子组件 表格内容修改回调
        handelCustomChange(data, prop, value) {
            this.$emit("handelTableChange", { data, prop, value })
        },
        // 表格内容修改回调
        handelTableChange(data, prop) {
            this.$emit("handelTableChange", { data, prop })
        },
        // 分页修改回调
        handelPageChange(type, value) {
            if (type == "size") {
                this.pageParams.pageSize = value
            } else {
                this.pageParams.current = value
            }
            this.search()
        },
        // 表格按钮回调
        handelBtnClick(type) {
            this.$emit("handelBtnClick", type)
        },
        reset() {
            this.tableFilter = JSON.parse(JSON.stringify(this.filterData))
            this.search()
        },
        confirm() {
            this.pageParams.current = 1
            this.search()
        },
        // 点击按钮回调
        search() {
            let params = {}
            this.tableFilter.forEach(el => {
                if (el.value || typeof el.value === "boolean") {
                    params[el.prop] = el.value
                }
            })
            if (this.hasPagination) {
                params.pageSize = this.pageParams.pageSize
                params.current = this.pageParams.current
            }
            this.$emit("init", params)
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-table {
    background-color: #fff;
    padding: 20px;

    .el-form-item {
        width: 100%;
        float: left;
        margin: 0 0 12px 0;
    }

    /deep/.el-form--inline .el-form-item__content {
        width: calc(100% - 120px);
    }

    .el-form--inline {
        overflow: hidden;
    }

    /deep/.el-table th.el-table__cell {
        background: #f5f5f5;
    }

    .el-button--text {
        padding: 5px 2px;
    }

    .filter {
        position: relative;
    }

    .btns {
        text-align: center;
        padding: 20px 0;
        border-bottom: 1px solid #dedede;
        margin-bottom: 20px;
    }

    .table {
        position: relative;

        .table-btns {
            text-align: right;
            margin-bottom: 20px;
        }
    }

    .pagination {
        text-align: center;
        margin-top: 12px;
    }

    /deep/.el-link {
        padding: 0 5px;
    }
}
</style>